import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Filters from './Filters';
import { exportBankTransferRequest } from '../../../requests/bankTransfers';
import { downloadFile } from '../../../services/utils';

const WireTransfer = () => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  const successCallback = response => {
    setDisabled(false);
    downloadFile(response);
  };

  const handleCreateBankTransfer = params => {
    setDisabled(true);
    const { financialInstitution, advancePaymentProcess, conceptType, processDate } = params;

    const bankTransferParams = {
      bank: financialInstitution.code,
      type: conceptType,
      ids: advancePaymentProcess,
      date: processDate,
      ...params
    };
    exportBankTransferRequest({
      dispatch,
      params: { ...bankTransferParams },
      format: financialInstitution.format,
      successCallback
    });
  };
  return (
    <>
      <Filters formRequest={handleCreateBankTransfer} disabled={disabled} />
    </>
  );
};

export default WireTransfer;
